// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"5b77acb2d8c1e4b286a7","883":"cc77ef61a9e482e8955a"}[chunkId] + ".js";
};